import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTrophy, FaMedal, FaGraduationCap, FaHandshake, FaChartLine, FaHeart, FaUsers, FaGlobe, FaLightbulb, FaBullseye, FaBook, FaClock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import bgImage from '../../assets/img/pictures/tttt.jpg';

const About = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const achievements = [
    { number: "25+", label: "Years Experience", icon: <FaChartLine /> },
    { number: "1000+", label: "Graduates", icon: <FaGraduationCap /> },
    { number: "20+", label: "Years of Excellence", icon: <FaTrophy /> },
    { number: "3", label: "Education Levels", icon: <FaBook /> }
  ];

  const values = [
    {
      title: "Excellence",
      icon: <FaTrophy className="text-yellow-400" />,
      description: "Striving for the highest standards in both academics and sports"
    },
    {
      title: "Holistic Development",
      icon: <FaChartLine className="text-green-400" />,
      description: "Balancing academic excellence with sporting achievements"
    },
    {
      title: "Professionalism",
      icon: <FaMedal className="text-red-400" />,
      description: "Maintaining high standards in all aspects of development"
    },
    {
      title: "Innovation",
      icon: <FaGlobe className="text-blue-400" />,
      description: "Embracing modern methods in education and sports"
    }
  ];

  const philosophyPoints = [
    {
      letter: "P",
      word: "Pride of the Academy",
      description: "Taking pride in our institution and achievements"
    },
    {
      letter: "R",
      word: "Respect and be Reliable",
      description: "Maintaining respect and reliability in all interactions"
    },
    {
      letter: "O",
      word: "Outstanding in all endeavours",
      description: "Striving for excellence in every aspect"
    },
    {
      letter: "F",
      word: "Friendly with all",
      description: "Promoting a welcoming and inclusive environment"
    },
    {
      letter: "E",
      word: "Encourage one another",
      description: "Supporting each other's growth and development"
    },
    {
      letter: "S",
      word: "Supportive of each other's",
      description: "Creating a supportive community"
    },
    {
      letter: "S",
      word: "Success-Driven",
      description: "Focused on achieving excellence"
    },
    {
      letter: "I",
      word: "Intelligent on and off pitch",
      description: "Developing both mental and physical capabilities"
    },
    {
      letter: "O",
      word: "Optimistic of outcomes",
      description: "Maintaining positive outlook"
    },
    {
      letter: "N",
      word: "Neat off and on the pitch",
      description: "Maintaining high standards of presentation"
    },
    {
      letter: "A",
      word: "Ambitious but Accountable",
      description: "Setting high goals while taking responsibility"
    },
    {
      letter: "L",
      word: "Learned Academically and sports",
      description: "Balancing academic and sporting knowledge"
    },
    {
      letter: "I",
      word: "Integrity",
      description: "Maintaining strong moral principles"
    },
    {
      letter: "S",
      word: "Strive for Excellence",
      description: "Continuously improving and growing"
    },
    {
      letter: "M",
      word: "Mission-Driven",
      description: "Focused on achieving our goals"
    }
  ];

  // const staffMembers = {
  //   leadership: [
  //     {
  //       name: "Maclean Kofi Abban",
  //       role: "Director",
  //       image: require("../../assets/img/pictures/abouts us - Copy.jpg")
  //     },
  //     {
  //       name: "Kenneth Ato Abban",
  //       role: "Staff",
  //       image: require("../../assets/img/pictures/ken pic.jpg")
  //     },
  //     {
  //       name: "George Abban",
  //       role: "Staff",
  //       image: require("../../assets/img/pictures/dp.jpg")
  //     },
  //     {
  //       name: "Francis Amanquanor",
  //       role: "Accountant",
  //       image: ""
  //     }
  //   ],
  //   coaching: [
  //     {
  //       name: "Steve Adams",
  //       role: "Main Coach",
  //       image: ""
  //     },
  //     {
  //       name: "Patrick Mensah ",
  //       role: "Assistant Coach",
  //       image: require("../../assets/img/pictures/pic m.jpg")      
  //     },
  //     {
  //       name: "Samuel Owusu Boakye",
  //       role: "Assistant Coach",
  //       image: ""
  //     },
  //     {
  //       name: "Emmanuel Anderson",
  //       role: "Assistant Coach",
  //       image: ""
  //     }
  //   ],
  //   scouting: [
  //     // {
  //     //   name: "Kwame Osei",
  //     //   role: "Scout - Greater Accra Region",
  //     //   image: "https://images.pexels.com/photos/5647791/pexels-photo-5647791.jpeg"
  //     // },
  //     // {
  //     //   name: "Yaw Boateng",
  //     //   role: "Scout - Ashanti Region",
  //     //   image: "https://images.pexels.com/photos/6180740/pexels-photo-6180740.jpeg"
  //     // },
  //     // {
  //     //   name: "Kofi Mensah",
  //     //   role: "Scout - Central Region",
  //     //   image: "https://images.pexels.com/photos/6180740/pexels-photo-6180740.jpeg"
  //     // },
  //     // {
  //     //   name: "Ama Asante",
  //     //   role: "Scout - Western Region",
  //     //   image: "https://images.pexels.com/photos/6180740/pexels-photo-6180740.jpeg"
  //     // }
  //   ]
  // };

  const ComingSoonModal = () => (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          onClick={() => setShowModal(false)}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaClock className="text-2xl text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Coming Soon!</h3>
              <p className="text-gray-600 mb-6">This feature is currently under development. Stay tuned for updates!</p>
              <button
                onClick={() => setShowModal(false)}
                className="bg-blue-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
              >
                Got it
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return (
    <div className="min-h-screen relative">
      <ComingSoonModal />
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <img
          src={bgImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95"></div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Hero Section */}
        <section className="relative py-20">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Welcome to Kempshot Sports Academy
                </h1>
                <p className="text-xl text-blue-100 mb-8">
                  Established since 28th November, 1998, we have been at the forefront of holistic education, 
                  combining academic excellence with sporting achievements.
                </p>
                <div className="flex flex-wrap gap-4">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowModal(true)}
                    className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    Our Story
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowModal(true)}
                    className="bg-white/10 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/20 transition-colors duration-200"
                  >
                    Learn More
                  </motion.button>
                </div>
              </motion.div>
              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                  <img
                    src={require("../../assets/img/pictures/abouts us.jpg")}
                    alt="Academy Training"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                  />
                  <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg">
                    <p className="text-sm font-semibold">Established 2024</p>
                    <p className="text-xs opacity-80">New Beginning</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-4xl mx-auto text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-6">Who We Are</h2>
              <p className="text-xl text-blue-100 mb-8">
                Kempshot is already a household name known for formal curricular education excellence for over 20 years in the education industry. 
                We have embarked on a holistic education by improving our co-curricular activities to enhance positively the formal curricular effect.
              </p>
              <p className="text-xl text-blue-100">
                Our co-curricular activities are sports-centred due to the numerous benefits sporting activities add to learning.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Vision & Mission Section */}
        <section className="py-16 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                className="bg-white/10 rounded-xl p-8"
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaLightbulb className="text-4xl text-yellow-400" />
                  <h2 className="text-2xl font-bold text-white">Our Vision</h2>
                </div>
                <ul className="space-y-4 text-blue-100">
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400">•</span>
                    <span>Produce more and better home-grown players for professional football/sports with technical excellence and tactical astute independent decision-making ability both on and off the field.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400">•</span>
                    <span>Provide inspirational facilities and support service to stimulate the talent in the youth.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400">•</span>
                    <span>Develop more coaches to complement Academy football within our catchment area.</span>
                  </li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                className="bg-white/10 rounded-xl p-8"
              >
                <div className="flex items-center gap-4 mb-6">
                  <FaBullseye className="text-4xl text-green-400" />
                  <h2 className="text-2xl font-bold text-white">Our Mission</h2>
                </div>
                <ul className="space-y-4 text-blue-100">
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400">•</span>
                    <span>Helping young players to maximise their potentials in football/sports along their academic.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400">•</span>
                    <span>Providing expert sports support service and advice to our players and their parents.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400">•</span>
                    <span>Ensuring that every young player enjoys and values their Academy experience.</span>
                  </li>
                </ul>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Philosophy Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-4">Academy Philosophy</h2>
              <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                Our philosophy is PROFESSIONALISM as a noun and as an acronym
              </p>
            </motion.div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {philosophyPoints.map((point, index) => (
                <motion.div
                  key={point.letter}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6"
                >
                  <div className="text-3xl font-bold text-blue-400 mb-2">{point.letter}</div>
                  <h3 className="text-lg font-semibold text-white mb-2">{point.word}</h3>
                  <p className="text-sm text-blue-100">{point.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Team Sections */}
        {/* {Object.entries(staffMembers).map(([category, members]) => (
          <section key={category} className="py-12">
            <div className="container mx-auto px-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center mb-12"
              >
                <h2 className="text-3xl font-bold text-white mb-4 capitalize">
                  {category.replace('_', ' ')} Team
                </h2>
                <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                  {category === 'leadership' && 'Meet the experienced professionals guiding our academy'}
                  {category === 'coaching' && 'Our dedicated coaching staff developing future stars'}
                  {category === 'scouting' && 'Expert talent identification across the region'}
                  {category === 'medical' && 'Keeping our players healthy and performing at their best'}
                  {category === 'support' && 'Essential staff ensuring smooth academy operations'}
                </p>
              </motion.div>

              {category === 'scouting' ? (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center col-span-full"
                >
                  <div className="text-4xl text-blue-400 mb-4">
                    <FaClock />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Scouting Team Coming Soon</h3>
                  <p className="text-blue-100">We're working on bringing you information about our expert scouting team. Stay tuned!</p>
                </motion.div>
              ) : (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {members.map((member, index) => (
                    <motion.div
                      key={member.name}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-start gap-4"
                    >
                      <div className="flex-shrink-0">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-20 h-20 rounded-full object-cover"
                        />
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-white">{member.name}</h3>
                        <p className="text-blue-400 text-sm mb-2">{member.role}</p>
                        <div className="space-y-1 text-xs text-blue-100">
                          <p>{member.credentials}</p>
                          <p>{member.experience}</p>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          </section>
        ))} */}

        {/* CTA Section */}
        <section className="py-16 bg-blue-600/20 backdrop-blur-sm">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Join Our Growing Sports Family
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Be part of a legacy of excellence in both academics and sports
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate('/auth/contact')}
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold text-lg hover:bg-blue-50 transition-colors duration-200"
            >
              Contact Us
            </motion.button>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default About; 